import { getWeekStart, getDateString } from "../utils/datetime";

// Icons
import {
  Camera,
  Clock,
  Flag,
  Clipboard,
  Hourglass,
  CurrencyDollar,
  Calendar,
  Server,
  ChartPie,
  Terminal,
  QuestionMarkCircle,
  OfficeBuilding,
  Collection,
} from "../components/icons/svg/outline/index";

/**
 * Navigation Links Configuration
 * Centralized configuration for all application navigation links
 * organized by user role/permission level
 */
export const getAppLinksConfig = (baseURL, today) => ({
  debug: [
    {
      label: "Worker Timesheet",
      icon: Terminal,
      href: `/app/timekeeping/worker-timesheet`,
      domain: "timekeeping",
      name: "worker-timesheet",
    },
    {
      label: "Payout Timesheet",
      icon: Terminal,
      href: `/app/timekeeping/payout-timesheets`,
      name: "timekeeping/payout-timesheets",
    },
    {
      label: "Ticket System Demo",
      icon: Flag,
      href: `/app/dev/ticket-demo`,
      domain: "development",
      name: "ticket-demo",
    },
  ],

  crew: [
    {
      label: "Clock In",
      icon: Clock,
      href: "/app/timekeeping/clock-in",
      domain: "timekeeping",
      name: "clock-in",
    },
    {
      label: "Shift Schedule",
      icon: Clipboard,
      href: "/app/timekeeping/worker-schedule",
      domain: "timekeeping",
      name: "worker-schedule",
    },
    {
      label: "Daily Dispatch",
      icon: Calendar,
      href: `/app/planning/dispatch/${getDateString(
        getWeekStart()
      )}`,
      domain: "planning",
      name: "dispatch",
    },
    {
      label: "R&S Shared Drive",
      icon: Server,
      href: "/app/files/drive",
      domain: "files",
      name: "drive",
    },
  ],

  field: [
    {
      label: "Clock In",
      icon: Clock,
      href: "/app/timekeeping/clock-in",
      domain: "timekeeping",
      name: "clock-in",
    },
    {
      label: "Shift Schedule",
      icon: Clipboard,
      href: "/app/timekeeping/worker-schedule",
      domain: "timekeeping",
      name: "worker-schedule",
    },
    {
      label: "Media Upload",
      icon: Camera,
      href: "/app/files/upload",
      domain: "files",
      name: "upload",
    },
  ],

  manager: [
    {
      label: "Labor Hours Log",
      icon: Clipboard,
      href: `/app/timekeeping/hours-log/${today}`,
      domain: "timekeeping",
      name: "hours-log",
    },
    {
      label: "Timesheet Payout Review",
      icon: Hourglass,
      href: `/app/timekeeping/payout-timesheets`,
      hasNotification: true,
      domain: "timekeeping",
      name: "pending-payout-timesheets",
    },
    {
      label: "T&M",
      icon: Flag,
      href: "/app/operations/tm-log",
      domain: "operations",
      name: "tm-log",
    },
    {
      label: "RFI",
      icon: QuestionMarkCircle,
      href: "/app/operations/rfi-log",
      domain: "operations",
      name: "rfi-log",
    },
  ],

  staff: [
    {
      label: "Projects Home",
      icon: OfficeBuilding,
      href: "/app/projects",
      domain: "projects",
      name: "projects",
    },
    {
      label: "Payroll",
      icon: CurrencyDollar,
      href: `${baseURL}documents/payroll/qb-weekly`,
      domain: "django",
      name: "payroll",
    },
    {
      label: "Planning Schedule",
      icon: Calendar,
      href: "/app/planning/schedule",
      domain: "planning",
      name: "schedule",
    },
    {
      label: "Daily Dispatch",
      icon: Calendar,
      href: `/app/planning/dispatch/${getDateString(
        getWeekStart()
      )}`,
      domain: "planning",
      name: "dispatch",
    },
    {
      label: "R&S Shared Drive",
      icon: Server,
      href: "/app/files/drive",
      domain: "files",
      name: "drive",
    },
  ],

  executive: [
    {
      label: "Daily Cost Analysis",
      icon: ChartPie,
      href: "/app/analytics/cost",
      domain: "analytics",
      name: "cost",
    },
    {
      label: "Safety Meeting Audit",
      icon: Clipboard,
      href: "/app/operations/safetymeeting",
      domain: "operations",
      name: "safetymeeting",
    },
    {
      label: "Work Scope Management",
      icon: Collection,
      href: "/app/office/work-scopes",
      domain: "office",
      name: "work-scopes",
    },
  ],
});
